import { Tooltip } from "antd";
import { ReactComponent as ReadIcon } from "../../../assets/icons/notification-read.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/notification-del.svg";
import Bell02 from "@untitled-ui/icons-react/build/esm/Bell02";

export default function NotificationCard({
    notification,
    handleDeleteNotification,
    handleReadNotification,
    handleDestinationPage,
    actionBtn,
    showDotOverBell = true
}) {
    return (
        <div
            key={notification?.id}
            className="frame-1000011389"
            onClick={() => handleDestinationPage(notification?.destinationPageURL)}>
            <div className="frame-92">
                <div className="frame-1000011384">
                    <Bell02 className="text-gray-100" height="16px" />
                    {showDotOverBell && <div className="ellipse-9"></div>}
                </div>
                <div className="frame-1000011386">
                    <div className="retailer-just-sent-a-reorder-check-it-out">{notification?.description}</div>
                    <div className="_2-h">{notification?.createdAt}</div>
                    <div className="action-group-btn">
                        {/* Delete button */}
                        {actionBtn?.read && (
                            <Tooltip
                                placement="top"
                                title={"DELETE"}
                                color="#212121"
                                overlayClassName="custom-tool-tip">
                                <div
                                    className="delete"
                                    onClick={e => {
                                        e.stopPropagation();
                                        handleDeleteNotification(notification?.id);
                                    }}>
                                    <DeleteIcon />
                                </div>
                            </Tooltip>
                        )}
                        {/* Mark as read button */}
                        {actionBtn?.delete && (
                            <Tooltip
                                placement="top"
                                title={"MARK AS READ"}
                                color="#212121"
                                overlayClassName="custom-tool-tip">
                                <div
                                    className="read"
                                    onClick={e => {
                                        e.stopPropagation();
                                        handleReadNotification(notification?.id);
                                    }}>
                                    <ReadIcon />
                                </div>
                            </Tooltip>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
